import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import axiosConfig from "../axiosInstance";

// export const useGetOrders = (businessId, filters) =>
//   useQuery({
//     queryKey: [
//       "getBusinessOrders",
//       businessId,
//       {
//         ...filters,
//       },
//     ],
//     queryFn: async () => {
//       if (!businessId) return [];
//       const response = await axiosConfig.get(`/orders/${businessId}`, {
//         params: filters,
//       });
//       return response.data;
//     },
//     enabled: !!businessId,
//   });

export const useGetOrders = (businessId, filters) => {
  return useQuery({
    queryKey: ["getBusinessOrders", businessId, filters],
    queryFn: async () => {
      const response = await axiosConfig.get(`/orders/${businessId}`, {
        params: filters,
      });
      return response.data;
    },
    enabled: !!businessId,
    placeholderData: businessId ? undefined : [],
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  });
};

export const useGetMerchantTransactions = (filters) => {
  return useQuery({
    queryKey: ["getMerchantTransactions", filters],
    queryFn: async () =>
      await axiosConfig.get(`/merchant/get/all/transactions`, {
        params: filters,
      }),
  });
};

export const useGetSingleOrder = (id) =>
  useQuery({
    queryKey: ["getSingleOrder", id],
    queryFn: async () => await axiosConfig.get(`/orders/getSingle/${id}`),
  });

export const useGetRefundByOrder = (refundId) =>
  useQuery({
    queryKey: ["getRefundByOrder", refundId],
    queryFn: async () => {
      const response = await axiosConfig.get(`/merchant/refund/${refundId}`);
      return response.data;
    },
    enabled: !!refundId,
  });

export const useGetMerchantRefunds = (activeBusiness, filters) =>
  useQuery({
    queryKey: ["getMerchantRefunds", { ...filters }],
    queryFn: async () => {
      const response = await axiosConfig.get(`/merchant/refund/merchant/all`, {
        params: filters,
      });
      return response.data;
    },
    enabled: !!activeBusiness,
  });

export const useApproveRefund = () =>
  useMutation({
    mutationKey: ["approveRefund"],
    mutationFn: async (refundId) =>
      await axiosConfig.post(`/merchant/refund/status/approve/${refundId}`),
  });

export const useDeclineRefund = () =>
  useMutation({
    mutationKey: ["declineRefund"],
    mutationFn: async (refundId) =>
      await axiosConfig.post(`/merchant/refund/status/decline/${refundId}`),
  });
